module.exports = __webpack_public_path__ + "img/icon_messenger.e05a59f9.svg";